module.exports = __webpack_public_path__ + "static/media/title.6fa31b8a.png";